import React, { useState, useEffect } from 'react';
import { Table, Input, InputNumber, Popconfirm, Button, Typography, Space, Avatar, Row } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import CustomDivider from '../../../../../v2-components/Antd/Divider';

const { Title, Text } = Typography;

export const MagistralProductForm = (props) => {
  const [expandedKeys, setExpandedKeys] = useState([]);





  useEffect(() => {
    if (
      props?.currentStatus !== 100 &&
      props?.magistralProducts?.length > 0
    ) {

      const isDifferent =
        props.products !== props.magistralProducts &&
        JSON.stringify(props.products) !== JSON.stringify(props.magistralProducts);

      if (isDifferent) {
        props?.handleSetProducts(props?.magistralProducts);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentStatus, props.magistralProducts]);

  const handleChange = (key, dataIndex, value) => {
    const updated = props?.products.map((item) =>
      item.key === key ? {
        ...item,
        [dataIndex]: value?.target?.value ?? value
      } : item
    );
    props?.handleSetProducts(updated);
  }; 

  const handleAdd = () => {
    const newKey = Date.now();
    const newItem = {
      key: newKey,
      name: '',
      quantity: 1,
      price: 0,
      specs: null,
    };

    props?.handleSetProducts([...props?.products, newItem])

    setExpandedKeys([...expandedKeys, newKey]);
  };

  const handleDelete = (key) => {
    props?.handleSetProducts(props?.products.filter((item) => item.key !== key));
    setExpandedKeys(expandedKeys.filter(k => k !== key)); 
  };

  const columns = [
    {
      title: 'Nombre del producto',
      dataIndex: 'name',
      editable: true,
      render: (_, record) => (
        <Input.TextArea
          value={record.name}
          disabled={props.currentStatus !== 100}
          autoSize
          onChange={(e) => handleChange(record.key, 'name', e)}
        />

      ),
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      editable: true,
      width: 100,
      render: (_, record) => (
        <InputNumber
          min={1}
          max={1}
          value={record.quantity}
          // disabled={props.currentStatus !== 200}
          disabled= {true}
          onChange={(val) => handleChange(record.key, 'quantity', val)}
        />
      ),
    },
    {
      title: 'Precio final u.',
      dataIndex: 'price',
      editable: true,
      width: 120,
      render: (_, record) => (
        <InputNumber
          min={0}
          value={record.price}
          disabled={props.currentStatus !== 100}
          onChange={(val) => handleChange(record.key, 'price', val)}
        />
      ),
    },
    {
      title: 'Eliminar',
      dataIndex: 'action',
      width: 80,
      render: (_, record) => (
        <Popconfirm title="¿Eliminar producto?" onConfirm={() => handleDelete(record.key)}>
          <Button disabled={props.currentStatus !== 100}
            icon={<DeleteOutlined />} danger type="text" />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24, background: '#fff', borderRadius: 8 }}>
      <Title level={4}>Carga de productos de recetario magistral</Title>
      <Text>Asegúrate de tener los ingredientes para confeccionar el producto a la brevedad.</Text>
      <CustomDivider />
      <Row>
        <Avatar
          style={{
            backgroundColor: '#1890ff',
            color: '#fff',
            border: '2px solid #1890ff',
            fontSize: 16,
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px'
          }}
          size={24}
        >
          1
        </Avatar>
        <Text>Escribir el nombre del producto de la receta, agregar stock y precio</Text>
      </Row>
      <Table
        dataSource={props?.products}
        columns={columns}
        pagination={false}
        rowKey="key"
        style={{ marginTop: 24 }}
        expandable={{
          expandedRowRender: (record) => (
            <div style={{ padding: '0 24px' }}>
              <Text strong>Especificaciones:</Text>
              <Input.TextArea
                autoSize
                disabled={props.currentStatus !==100}
                placeholder="Sabor, color, aplicación, tipo de producto"
                value={record.specs}
                onChange={(e) => handleChange(record.key, 'specs', e)}
                style={{ marginTop: 4 }}
              />
            </div>
          ),
          expandedRowKeys: expandedKeys,
          onExpand: (expanded, record) => {
            if (expanded) {
              setExpandedKeys([...expandedKeys, record.key]);
            } else {
              setExpandedKeys(expandedKeys.filter(key => key !== record.key));
            }
          },
        }}
      />

      <Space style={{ marginTop: 16, justifyContent: 'end', width: '100%' }}>
        <Button type="primary" disabled={props?.products?.length > 0} onClick={handleAdd}>
          Agregar
        </Button>
      </Space>
    </div>
  );
};